import { Container } from '@react-email/components';
import { merge } from 'lodash';

const spacer = {
    EditorElement: props => {
        const { attributes, children, element } = props;
        const containerStyle = {
            style: {
                maxWidth: '100%',
            },
        };
        return (
            <Container
                contentEditable={false}
                {...attributes}
                {...merge(containerStyle, element.attributes)}
            >
                {children}
            </Container>
        );
    },
    PreviewElement: ({ node, attributes }) => {
        const containerStyle = {
            style: {
                maxWidth: '100%',
            },
        };
        return (
            <Container
                {...merge({}, node.attributes, containerStyle)}
            ></Container>
        );
    },
};

export default spacer;
